import { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getInsuranceCompanies } from "../../../../services/consignado/insurance-company.service";

interface Props {
  onChange: (value: string | null) => void;
  value?: string | { value: string; label: string };
  selectedInsuranceCompanyId?: string;
  error?: string;
  touched?: boolean;
}

const InsuranceCompanyProductsSelect = ({
  onChange,
  value,
  selectedInsuranceCompanyId,
  error, 
  touched
}: Props) => {
  const [defaultOption, setDefaultOption] = useState<any>(null);

  const isInvalid = touched && !!error;

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      margin: "4px 0 0 0",
      backgroundColor: "white",
      borderColor: isInvalid ? "#E53E3E" : (state.isFocused ? "#3182ce" : "#E2E8F0"), 
      borderRadius: "0.35rem", 
      minHeight: "40px", 
      boxShadow: isInvalid ? "0 0 0 1px #E53E3E" : (state.isFocused ? "0 0 0 1px #3182ce" : "none"),
      "&:hover": {
        borderColor: isInvalid ? "#E53E3E" : (state.isFocused ? "#3182ce" : "#cbd5e0"),
      }
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
  };

  useEffect(() => {
    const loadInitialValue = async () => {
      if (!selectedInsuranceCompanyId) {
        setDefaultOption(null);
        return;
      }

      if (!value || (typeof value === "string" && !value.trim())) {
        setDefaultOption(null);
        return;
      }

      if (typeof value === "string") {
        try {
          const data = await getInsuranceCompanies({ page: 0, pageSize: 50 });
          const company = data.find(
            (el) => el.id === selectedInsuranceCompanyId
          );
          const product = company?.coverage_products?.find(
            (p: any) => String(p.id) === String(value).trim()  // ← ALTERAÇÃO AQUI
          );

          if (product) {
            setDefaultOption({ value: String(product.id).trim(), label: product.name });
          }
        } catch (err) {
          console.error("Erro ao carregar valor inicial:", err);
        }
      } else if (value && typeof value === "object") {
        // Caso já venha pronto
        setDefaultOption(value);
      }
    };

    loadInitialValue();
  }, [value, selectedInsuranceCompanyId]);

  const loadOptions = async () => {
    if (!selectedInsuranceCompanyId) return { options: [] };

    const data = await getInsuranceCompanies({ page: 0, pageSize: 50 });
    const selectedCompany = data.find(
      (el) => el.id === selectedInsuranceCompanyId
    );
    const products = selectedCompany?.coverage_products ?? [];

    return {
      options: products.map((item: any) => ({
        value: item.id.toString(),
        label: item.name,
      })),
    };
  };

  return (
    <div style={{ width: "100%" }}>
      <label style={{ color: isInvalid ? "#E53E3E" : "inherit" }}>Produto seguradora</label>
      <AsyncPaginate
        menuPortalTarget={document.body} // Faz o menu flutuar sobre tudo
        menuPosition="fixed"
        styles={customStyles}
        key={selectedInsuranceCompanyId || 'empty'}
        value={defaultOption}
        loadOptions={loadOptions as any}
        onChange={(selected: any) => onChange(selected?.value || null)}
        additional={{ page: 0 }}
        debounceTimeout={400}
        isClearable
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        cacheUniqs={[selectedInsuranceCompanyId]}
      />
      {isInvalid && (
        <div style={{ color: "#E53E3E", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default InsuranceCompanyProductsSelect;
